export default __webpack_public_path__ + "static/drag-img-13da1a042bd2a079e10f3e5e94a9da7b.png";